import { isReadItemInitiallyCollapsed } from 'src/domain/org'
import { Register } from '../../type'

// 初期展開状態はエラー行のみ。ハイライトは展開行にのみ表示される仕様のため、
// エラーのない行のハイライトはユーザーが手動展開するまで非表示となる（意図的な挙動）
// NOTE: isReadItemInitiallyCollapsed(orgCode) が true の org（例: 009）は、
//       エラー行も含めて全行を初期状態で閉じる（トグル操作自体は残るため手動展開は可能）。
// NOTE: 009 は OCRハイライト対象org（ENABLE_OCR_HIGHLIGHT_ORG_CODES）だが、初期状態で全行を
//       閉じるため、ハイライトも初期表示では表示されない（手動展開すれば表示される）。
//       009 では数値確認を優先し初期表示でハイライトを出さない挙動で問題ない旨を確認済み（Issue #3589）。
export const buildExpandedRows = (
  registers: Register[],
  orgCode: string
): Map<number, Set<number>> => {
  const collapseInitially = isReadItemInitiallyCollapsed(orgCode)
  const map = new Map<number, Set<number>>()
  registers.forEach((register, ri) => {
    const expanded = new Set<number>()
    if (!collapseInitially) {
      register.rows.forEach((row, rowIdx) => {
        if (row.error) expanded.add(rowIdx)
      })
    }
    map.set(ri, expanded)
  })
  return map
}
